import React, {ReactNode} from "react"
import {ErrorMessage, Field, FieldProps} from "formik"
import classNames from "classnames"
import * as Yup from "yup"
import {validateYupField} from "../utils"

/*
 * TODO: Consider to make fields with formik field wrapper globally in the project
 */

interface TextFieldProps {
	name: string
	label: string
	placeholder?: string
	validationSchema?: Yup.AnySchema
	helpElements?: ReactNode
	type?: "text" | "textarea"
	rows?: number
	additionalContent?: ReactNode
	optional?: boolean
}

export default function TextField({
	name,
	label,
	placeholder,
	validationSchema,
	helpElements,
	type = "text",
	rows,
	additionalContent,
	optional = false,
}: TextFieldProps) {
	return (
		<div className="field">
			<div className={classNames("label-wrapper", {"label-with-help": helpElements})}>
				<label className="label" htmlFor={name}>
					{label} {optional && <span className="field-tag">(Optional)</span>}
				</label>
				{helpElements && <div className="help-elements">{helpElements}</div>}
			</div>
			<div className="control">
				<Field name={name} validate={validationSchema ? validateYupField(validationSchema) : undefined}>
					{({field: {onChange, value, name, onBlur}, meta: {error}}: FieldProps<string>) => {
						return type === "textarea" ? (
							<textarea
								id={name}
								name={name}
								className={classNames("textarea has-fixed-size", {
									"is-danger": error,
									"validation-error": error,
								})}
								placeholder={placeholder}
								value={value || ""}
								onChange={onChange}
								onBlur={onBlur}
								rows={rows}
							/>
						) : (
							<input
								id={name}
								name={name}
								className={classNames("input", {
									"is-danger": error,
									"validation-error": error,
								})}
								type="text"
								placeholder={placeholder}
								value={value || ""}
								onChange={onChange}
								onBlur={onBlur}
							/>
						)
					}}
				</Field>
				<ErrorMessage name={name} component="div" className="has-text-danger" />
				{additionalContent && additionalContent}
			</div>
		</div>
	)
}
